/* Copyright (c) 2018 Scaper */

import { parse, stringify } from "query-string";
import { RouteComponentProps } from "react-router";
import { APP_PATH } from "../appPath";

export interface IConfirmPhoneNumberRouteParams {
    from?: string;
}

export const CONFIRM_PHONE_NUMBER_PATH = `${APP_PATH}/confirm-phone-number`;

export const ConfirmPhoneNumberPath = {
    of: (params?: IConfirmPhoneNumberRouteParams) => {
        const queryString = params != null ? `?${stringify(params)}` : "";
        return `${CONFIRM_PHONE_NUMBER_PATH}${queryString}`;
    },
    parse: (props: RouteComponentProps<IConfirmPhoneNumberRouteParams>) => {
        const pathParams = props.match.params;
        const queryParams = parse(props.location.search);
        return { ...pathParams, ...queryParams };
    },
};
